<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มหมายเลขแทร็กกิ้งเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h2>คำสั่งซื้อดำเนินการ</h2>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.order_code}}</td>
                        <td>{{dataDetail.item.customer_name}}</td>
                        <td>{{dataDetail.item.total_price}}</td>
                        <td>{{dataDetail.item.created_at}}</td>
                        <td :class="dataDetail.item.status == 1 ? 'warning--text' : 'success--text'">{{dataDetail.item.status == 1 ? 'ดำเนินการ' : 'คำสั่งซื้อใหม่'}}</td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" width="50">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item class="cursor_content_order_list" @click="confirmAddTrackNumber(dataDetail.item.id)" v-if="dataDetail.item.status == 1">
                                        <v-list-item-title>เพิ่มหมายเลขแทร็กกิ้ง</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor_content_order_list" @click="orderDetail(dataDetail.item.id)">
                                        <v-list-item-title>รายละเอียดคำสั่งซื้อ</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <!-- เพิ่มหมายเลขแทร็กกิ้ง -->
        <v-dialog v-model="open_add_track_number" persistent max-width="600px">
            <v-card>
                <v-form ref="form_add" @submit.prevent="addTrackNumber()">
                    <v-card-title class="justify-space-between">
                        <div>
                            เพิ่มหมายเลขแทร็กกิ้ง
                        </div>
                        <div class="cursor_content_order_list" @click="open_add_track_number = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>

                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="หมายเลขแทร็กกิ้ง" :rules="[v => !!v || 'กรุณากรอกหมายเลขแทร็กกิ้ง']" v-model="track_number" required outlined></v-text-field>
                            </v-col>
                        </v-row>

                    </v-card-text>

                    <v-card-actions class="justify-center">
                        <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="60">
                            บันทึก
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import contentorder from '@/api/content/contentpurchase/contentorder.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            open_add_track_number: false,
            edit_id: null,
            track_number: null,
            search: '',
            headers: [{
                    text: 'รหัสคำสั่งซื้อ',
                    align: 'start',
                    value: 'order_code',
                },
                {
                    text: 'ลูกค้า',
                    value: 'customer_name'
                },
                {
                    text: 'ยอดรวม',
                    value: 'total_price'
                },
                {
                    text: 'วันที่สั่งซื้อ',
                    value: 'created_at'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async orderList() {
            this.loading_page = true
            this.data = []
            contentorder.orderList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.orders
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async confirmAddTrackNumber(id) {
            this.open_add_track_number = true
            this.edit_id = id
            this.track_number = null
        },
        async addTrackNumber() {
            if (this.$refs.form_add.validate()) {
                this.loading_page = true
                this.open_add_track_number = false
                const data = {
                    track_number: this.track_number
                }
                contentorder.addTrackNumber(this.edit_id, data).then((response) => {
                    if (response.data.successful === true) {
                        this.edit_id = null
                        this.track_number = null
                        this.orderList()
                        this.alert_show_add = true
                        setTimeout(() => this.alert_show_add = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            }
        },
        async orderDetail(id) {
            const idPage = {
                id: id
            }
            this.$store.commit('detailContentOrderPage', idPage)
            this.$router.push('/contentorderdetail/ordermanage')
        }
    },
    mounted() {
        this.orderList()
    }
}
</script>

<style scoped>
.cursor_content_order_list {
    cursor: pointer;
}
</style>
